import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Label,
  Row,
  Button,
  Input,
  Table,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Badge,
} from 'reactstrap';
import NavBar from '../components/NavBar';
import { REQUEST_URL } from '../config/urls';

const Produtos = (props) => {
  const storagedUser = sessionStorage.getItem('usuarioLogado');
  const usuarioLogado = storagedUser ? JSON.parse(storagedUser)[0] : undefined;

  const servicos = [
    'CAPA DURA',
    'MIOLO',
    'SIMPLES',
    'ENCARTE',
    'EMBALAGEM',
    'OUTROS',
  ];

  const [modoVisualizacao, setModoVisualizacao] = useState('produtos');

  const [servicoSelecionado, setServicoSelecionado] = useState('');
  const [projetos, setProjetos] = useState([]);
  const [projetoSelecionado, setProjetoSelecionado] = useState(null);
  const [itens, setItens] = useState([]);
  const [itemSelecionado, setItemSelecionado] = useState(null);
  const [descricoes, setDescricoes] = useState([]);
  const [descricaoSelecionada, setDescricaoSelecionada] = useState(null);
  const [listaPrecos, setListaPrecos] = useState([]);
  const [linhaEditando, setLinhaEditando] = useState(null);
  const [valorEditando, setValorEditando] = useState('');
  const [carregando, setCarregando] = useState(false);

  const [valorPercentual, setValorPercentual] = useState('');

  const [modalConfirmacao, setModalConfirmacao] = useState(false);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [nivelAjuste, setNivelAjuste] = useState('');

  const [servicoAcabSelecionado, setServicoAcabSelecionado] = useState('');
  const [acabamentos, setAcabamentos] = useState([]);
  const [acabamentoSelecionado, setAcabamentoSelecionado] = useState(null);
  const [listaPrecosAcab, setListaPrecosAcab] = useState([]);
  const [linhaEditandoAcab, setLinhaEditandoAcab] = useState(null);
  const [valorEditandoAcab, setValorEditandoAcab] = useState('');
  const [valorPercentualAcab, setValorPercentualAcab] = useState('');

  const [modalNovoProduto, setModalNovoProduto] = useState(false);
  const [novoProdutoCategoria, setNovoProdutoCategoria] = useState('');
  const [novoProdutoTipo, setNovoProdutoTipo] = useState('');
  const [novoProdutoNome, setNovoProdutoNome] = useState('');
  const [novoProdutoTamanho, setNovoProdutoTamanho] = useState('');
  const [novoProdutoComponente, setNovoProdutoComponente] = useState('');
  const [novoProdutoFaixas, setNovoProdutoFaixas] = useState([{ qtd: '', preco: '' }]);
  const [tiposDisponiveis, setTiposDisponiveis] = useState([]);

  function validateAccess() {
    if (usuarioLogado) {
      if (!(usuarioLogado.Nivel === 'SENIOR' && usuarioLogado.Funcao === 'ORCAMENTISTA')) {
        props.history.push('/mapa');
      }
    }
  }

  useEffect(function() {
    axios.defaults.headers.common = {
      Authorization: sessionStorage.getItem('token'),
    };
    validateAccess();
  }, []);

  var recarregarPrecos = async function() {
    if (descricaoSelecionada) {
      var response = await axios.post(REQUEST_URL + '/Produto/lista_precos', {
        item: descricaoSelecionada,
      });
      setListaPrecos(response.data);
    }
  };

  var selecionarServico = async function(servico) {
    setServicoSelecionado(servico);
    setProjetos([]);
    setProjetoSelecionado(null);
    setItens([]);
    setItemSelecionado(null);
    setDescricoes([]);
    setDescricaoSelecionada(null);
    setListaPrecos([]);
    setLinhaEditando(null);
    setValorEditando('');
    setValorPercentual('');

    if (!servico) return;

    setCarregando(true);
    try {
      console.log('Buscando projetos para:', servico);
      var response = await axios.post(REQUEST_URL + '/Produto/listarProjetos', {
        servico: servico,
      }, { timeout: 30000 });
      console.log('Projetos recebidos:', response.data);
      setProjetos(response.data || []);
    } catch (error) {
      console.error('Erro ao carregar projetos:', error);
      var errorMsg = error.response && error.response.data && error.response.data.error ? error.response.data.error : error.message;
      toast.error('Erro ao carregar projetos: ' + errorMsg);
    }
    setCarregando(false);
  };

  var selecionarProjeto = async function(projeto) {
    if (!projeto) {
      setProjetoSelecionado(null);
      setItens([]);
      setItemSelecionado(null);
      setDescricoes([]);
      setDescricaoSelecionada(null);
      setListaPrecos([]);
      return;
    }

    var projetoObj = projetos.find(function(p) { return p.IDProject === parseInt(projeto); });
    setProjetoSelecionado(projetoObj);
    setItens([]);
    setItemSelecionado(null);
    setDescricoes([]);
    setDescricaoSelecionada(null);
    setListaPrecos([]);
    setLinhaEditando(null);
    setValorEditando('');
    setValorPercentual('');

    setCarregando(true);
    try {
      console.log('Buscando itens para projeto:', projetoObj);
      var response = await axios.post(REQUEST_URL + '/Produto/selecionarDescricao', { projeto: projetoObj }, { timeout: 30000 });
      console.log('Itens recebidos:', response.data);
      setItens(response.data || []);
    } catch (error) {
      console.error('Erro ao carregar itens:', error);
      var errorMsg = error.response && error.response.data && error.response.data.error ? error.response.data.error : error.message;
      toast.error('Erro ao carregar itens: ' + errorMsg);
    }
    setCarregando(false);
  };

  var selecionarItem = async function(item) {
    if (!item) {
      setItemSelecionado(null);
      setDescricoes([]);
      setDescricaoSelecionada(null);
      setListaPrecos([]);
      return;
    }

    var itemObj = itens.find(function(i) { return i.IdQuote === parseInt(item); });
    setItemSelecionado(itemObj);
    setDescricoes([]);
    setDescricaoSelecionada(null);
    setListaPrecos([]);
    setLinhaEditando(null);
    setValorEditando('');
    setValorPercentual('');

    setCarregando(true);
    try {
      console.log('Buscando descricoes para item:', itemObj);
      var response = await axios.post(REQUEST_URL + '/Produto/listaDescricao', { item: itemObj }, { timeout: 30000 });
      console.log('Descricoes recebidas:', response.data);
      setDescricoes(response.data || []);
    } catch (error) {
      console.error('Erro ao carregar descricoes:', error);
      var errorMsg = error.response && error.response.data && error.response.data.error ? error.response.data.error : error.message;
      toast.error('Erro ao carregar descricoes: ' + errorMsg);
    }
    setCarregando(false);
  };

  var selecionarDescricao = async function(descricao) {
    if (!descricao) {
      setDescricaoSelecionada(null);
      setListaPrecos([]);
      return;
    }

    var descObj = descricoes.find(function(d) { return d.Description === descricao; });
    setDescricaoSelecionada(descObj);
    setListaPrecos([]);
    setLinhaEditando(null);
    setValorEditando('');
    setValorPercentual('');

    setCarregando(true);
    try {
      var response = await axios.post(REQUEST_URL + '/Produto/lista_precos', { item: descObj }, { timeout: 30000 });
      setListaPrecos(response.data || []);
    } catch (error) {
      console.error('Erro ao carregar precos:', error);
      var errorMsg = error.response && error.response.data && error.response.data.error ? error.response.data.error : error.message;
      toast.error('Erro ao carregar precos: ' + errorMsg);
    }
    setCarregando(false);
  };

  var iniciarEdicaoLinha = function(index, precoAtual) {
    setLinhaEditando(index);
    setValorEditando(precoAtual.toFixed(2));
    setValorPercentual('');
  };

  var cancelarEdicao = function() {
    setLinhaEditando(null);
    setValorEditando('');
  };

  var salvarLinhaIndividual = async function(preco) {
    var novoPrecoUnitario = parseFloat(valorEditando);

    if (isNaN(novoPrecoUnitario) || novoPrecoUnitario < 0) {
      toast.warning('Preco invalido');
      return;
    }

    setCarregando(true);
    try {
      await axios.put(REQUEST_URL + '/Produto/atualizar_preco_linha', {
        IdQuote: preco.IdQuote,
        Description: preco.Description,
        QtdTotal: preco.QtdTotal,
        novoPrecoUnitario: novoPrecoUnitario,
      });

      toast.success('Preco atualizado!');
      setLinhaEditando(null);
      setValorEditando('');
      await recarregarPrecos();
    } catch (error) {
      toast.error('Erro ao atualizar preco');
    }
    setCarregando(false);
  };

  var calcularPercentual = function(valorAntigo, valorNovo) {
    if (!valorAntigo || valorAntigo === 0) return 0;
    return ((valorNovo - valorAntigo) / valorAntigo) * 100;
  };

  var contarRegistros = async function(escopo) {
    var identificador, description;

    switch (escopo) {
      case 'item':
        identificador = descricaoSelecionada.IdQuote;
        description = descricaoSelecionada.Description;
        break;
      case 'projeto':
        identificador = projetoSelecionado.IDProject;
        break;
      case 'servico':
        identificador = servicoSelecionado;
        break;
      default:
        return 0;
    }

    try {
      var response = await axios.post(REQUEST_URL + '/Produto/contar_registros', {
        escopo: escopo,
        identificador: identificador,
        description: description,
      });
      return response.data.total;
    } catch (error) {
      toast.error('Erro ao contar registros');
      return 0;
    }
  };

  var abrirModalConfirmacao = async function(nivel) {
    if (!valorPercentual || valorPercentual === '') {
      toast.warning('Informe o percentual de ajuste');
      return;
    }

    var total = await contarRegistros(nivel);
    if (total === 0) {
      toast.warning('Nenhum registro encontrado');
      return;
    }

    setNivelAjuste(nivel);
    setTotalRegistros(total);
    setModalConfirmacao(true);
  };

  var aplicarAlteracao = async function() {
    setModalConfirmacao(false);
    setCarregando(true);

    var identificador, description;

    switch (nivelAjuste) {
      case 'item':
        identificador = descricaoSelecionada.IdQuote;
        description = descricaoSelecionada.Description;
        break;
      case 'projeto':
        identificador = projetoSelecionado.IDProject;
        break;
      case 'servico':
        identificador = servicoSelecionado;
        break;
      default:
        setCarregando(false);
        return;
    }

    try {
      await axios.put(REQUEST_URL + '/Produto/atualizar_precos_percentual', {
        escopo: nivelAjuste,
        identificador: identificador,
        percentual: parseFloat(valorPercentual),
        description: description,
      });

      toast.success('Precos atualizados!');
      setValorPercentual('');
      await recarregarPrecos();
    } catch (error) {
      toast.error('Erro ao atualizar precos');
    }

    setCarregando(false);
  };

  var formatarMoeda = function(valor) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(valor);
  };

  var getNivelLabel = function() {
    if (modoVisualizacao === 'acabamentos') {
      switch (nivelAjuste) {
        case 'item':
          return acabamentoSelecionado ? acabamentoSelecionado.DescrComponente : '';
        case 'servico':
          return 'Toda categoria ' + servicoAcabSelecionado;
        default:
          return '';
      }
    }
    switch (nivelAjuste) {
      case 'item':
        return descricaoSelecionada ? descricaoSelecionada.DescProoduto : '';
      case 'projeto':
        return projetoSelecionado ? projetoSelecionado.DescrProjeto : '';
      case 'servico':
        return 'Toda categoria ' + servicoSelecionado;
      default:
        return '';
    }
  };

  var trocarModo = function(modo) {
    setModoVisualizacao(modo);
    setServicoSelecionado('');
    setProjetos([]);
    setProjetoSelecionado(null);
    setItens([]);
    setItemSelecionado(null);
    setDescricoes([]);
    setDescricaoSelecionada(null);
    setListaPrecos([]);
    setLinhaEditando(null);
    setValorEditando('');
    setValorPercentual('');
    setServicoAcabSelecionado('');
    setAcabamentos([]);
    setAcabamentoSelecionado(null);
    setListaPrecosAcab([]);
    setLinhaEditandoAcab(null);
    setValorEditandoAcab('');
    setValorPercentualAcab('');
  };

  var selecionarServicoAcab = async function(servico) {
    setServicoAcabSelecionado(servico);
    setAcabamentos([]);
    setAcabamentoSelecionado(null);
    setListaPrecosAcab([]);
    setLinhaEditandoAcab(null);
    setValorEditandoAcab('');
    setValorPercentualAcab('');

    if (!servico) return;

    setCarregando(true);
    try {
      var response = await axios.post(REQUEST_URL + '/Produto/listar_acabamentos_por_servico', {
        servico: servico,
      });
      var acabamentosUnicos = [];
      var idsVistos = {};
      response.data.forEach(function(item) {
        if (!idsVistos[item.IdOpcaoProduto]) {
          idsVistos[item.IdOpcaoProduto] = true;
          acabamentosUnicos.push(item);
        }
      });
      setAcabamentos(acabamentosUnicos);
    } catch (error) {
      toast.error('Erro ao carregar acabamentos');
    }
    setCarregando(false);
  };

  var selecionarAcabamento = async function(idOpcaoProduto) {
    if (!idOpcaoProduto) {
      setAcabamentoSelecionado(null);
      setListaPrecosAcab([]);
      return;
    }

    var acabObj = acabamentos.find(function(a) { return a.IdOpcaoProduto === parseInt(idOpcaoProduto); });
    setAcabamentoSelecionado(acabObj);
    setListaPrecosAcab([]);
    setLinhaEditandoAcab(null);
    setValorEditandoAcab('');
    setValorPercentualAcab('');

    setCarregando(true);
    try {
      var response = await axios.post(REQUEST_URL + '/Produto/lista_precos_acabamentos_detalhe', { item: acabObj });
      setListaPrecosAcab(response.data);
    } catch (error) {
      toast.error('Erro ao carregar precos de acabamentos');
    }
    setCarregando(false);
  };

  var recarregarPrecosAcab = async function() {
    if (acabamentoSelecionado) {
      var response = await axios.post(REQUEST_URL + '/Produto/lista_precos_acabamentos_detalhe', {
        item: acabamentoSelecionado,
      });
      setListaPrecosAcab(response.data);
    }
  };

  var iniciarEdicaoLinhaAcab = function(index, precoAtual) {
    setLinhaEditandoAcab(index);
    setValorEditandoAcab(precoAtual.toFixed(2));
    setValorPercentualAcab('');
  };

  var cancelarEdicaoAcab = function() {
    setLinhaEditandoAcab(null);
    setValorEditandoAcab('');
  };

  var salvarLinhaIndividualAcab = async function(preco) {
    var novoPrecoUnitario = parseFloat(valorEditandoAcab);

    if (isNaN(novoPrecoUnitario) || novoPrecoUnitario < 0) {
      toast.warning('Preco invalido');
      return;
    }

    setCarregando(true);
    try {
      await axios.put(REQUEST_URL + '/Produto/atualizar_preco_linha_acabamento', {
        IdOpcaoProduto: preco.IdOpcaoProduto,
        QtdTotal: preco.QtdTotal,
        novoPrecoUnitario: novoPrecoUnitario,
      });

      toast.success('Preco de acabamento atualizado!');
      setLinhaEditandoAcab(null);
      setValorEditandoAcab('');
      await recarregarPrecosAcab();
    } catch (error) {
      toast.error('Erro ao atualizar preco de acabamento');
    }
    setCarregando(false);
  };

  var contarRegistrosAcab = async function(escopo) {
    var identificador;

    switch (escopo) {
      case 'item':
        identificador = acabamentoSelecionado.IdOpcaoProduto;
        break;
      case 'servico':
        identificador = servicoAcabSelecionado;
        break;
      default:
        return 0;
    }

    try {
      var response = await axios.post(REQUEST_URL + '/Produto/contar_registros_acabamentos', {
        escopo: escopo,
        identificador: identificador,
      });
      return response.data.total;
    } catch (error) {
      toast.error('Erro ao contar registros de acabamentos');
      return 0;
    }
  };

  var abrirModalConfirmacaoAcab = async function(nivel) {
    if (!valorPercentualAcab || valorPercentualAcab === '') {
      toast.warning('Informe o percentual de ajuste');
      return;
    }

    var total = await contarRegistrosAcab(nivel);
    if (total === 0) {
      toast.warning('Nenhum registro encontrado');
      return;
    }

    setNivelAjuste(nivel);
    setTotalRegistros(total);
    setModalConfirmacao(true);
  };

  var aplicarAlteracaoAcab = async function() {
    setModalConfirmacao(false);
    setCarregando(true);

    var identificador;

    switch (nivelAjuste) {
      case 'item':
        identificador = acabamentoSelecionado.IdOpcaoProduto;
        break;
      case 'servico':
        identificador = servicoAcabSelecionado;
        break;
      default:
        setCarregando(false);
        return;
    }

    try {
      await axios.put(REQUEST_URL + '/Produto/atualizar_precos_acabamentos_percentual', {
        escopo: nivelAjuste,
        identificador: identificador,
        percentual: parseFloat(valorPercentualAcab),
      });

      toast.success('Precos de acabamentos atualizados!');
      setValorPercentualAcab('');
      await recarregarPrecosAcab();
    } catch (error) {
      toast.error('Erro ao atualizar precos de acabamentos');
    }

    setCarregando(false);
  };

  var abrirModalNovoProduto = function() {
    setNovoProdutoCategoria('');
    setNovoProdutoTipo('');
    setNovoProdutoNome('');
    setNovoProdutoTamanho('');
    setNovoProdutoComponente('');
    setNovoProdutoFaixas([{ qtd: '', preco: '' }]);
    setTiposDisponiveis([]);
    setModalNovoProduto(true);
  };

  var fecharModalNovoProduto = function() {
    setModalNovoProduto(false);
    setNovoProdutoCategoria('');
    setNovoProdutoTipo('');
    setNovoProdutoNome('');
    setNovoProdutoTamanho('');
    setNovoProdutoComponente('');
    setNovoProdutoFaixas([{ qtd: '', preco: '' }]);
    setTiposDisponiveis([]);
  };

  var selecionarCategoriaNovoProduto = async function(categoria) {
    setNovoProdutoCategoria(categoria);
    setNovoProdutoTipo('');
    setTiposDisponiveis([]);

    if (!categoria) return;

    try {
      var response = await axios.post(REQUEST_URL + '/Produto/listarProjetos', {
        servico: categoria,
      });
      setTiposDisponiveis(response.data);
    } catch (error) {
      toast.error('Erro ao carregar tipos');
    }
  };

  var adicionarFaixaPreco = function() {
    setNovoProdutoFaixas([].concat(novoProdutoFaixas, [{ qtd: '', preco: '' }]));
  };

  var removerFaixaPreco = function(index) {
    if (novoProdutoFaixas.length > 1) {
      var novasFaixas = novoProdutoFaixas.filter(function(_, i) { return i !== index; });
      setNovoProdutoFaixas(novasFaixas);
    }
  };

  var atualizarFaixaPreco = function(index, campo, valor) {
    var novasFaixas = novoProdutoFaixas.map(function(faixa, i) {
      if (i === index) {
        var novaFaixa = {};
        novaFaixa.qtd = faixa.qtd;
        novaFaixa.preco = faixa.preco;
        novaFaixa[campo] = valor;
        return novaFaixa;
      }
      return faixa;
    });
    setNovoProdutoFaixas(novasFaixas);
  };

  var validarNovoProduto = function() {
    if (!novoProdutoCategoria) {
      toast.warning('Selecione uma categoria');
      return false;
    }
    if (!novoProdutoTipo) {
      toast.warning('Selecione um tipo');
      return false;
    }
    if (!novoProdutoNome || novoProdutoNome.trim() === '') {
      toast.warning('Informe o nome do produto');
      return false;
    }
    if (!novoProdutoTamanho || novoProdutoTamanho.trim() === '') {
      toast.warning('Informe o tamanho do produto');
      return false;
    }

    for (var i = 0; i < novoProdutoFaixas.length; i++) {
      var faixa = novoProdutoFaixas[i];
      var qtd = parseInt(faixa.qtd);
      var preco = parseFloat(faixa.preco);

      if (!faixa.qtd || isNaN(qtd) || qtd <= 0) {
        toast.warning('Faixa ' + (i + 1) + ': quantidade invalida');
        return false;
      }
      if (!faixa.preco || isNaN(preco) || preco <= 0) {
        toast.warning('Faixa ' + (i + 1) + ': preco invalido');
        return false;
      }
    }

    var qtds = novoProdutoFaixas.map(function(f) { return parseInt(f.qtd); });
    var qtdsUnicas = [];
    qtds.forEach(function(q) {
      if (qtdsUnicas.indexOf(q) === -1) {
        qtdsUnicas.push(q);
      }
    });
    if (qtds.length !== qtdsUnicas.length) {
      toast.warning('Existem quantidades duplicadas nas faixas de preco');
      return false;
    }

    return true;
  };

  var salvarNovoProduto = async function() {
    if (!validarNovoProduto()) return;

    var tipoSelecionado = tiposDisponiveis.find(function(t) { return t.IDProject === parseInt(novoProdutoTipo); });
    if (!tipoSelecionado) {
      toast.error('Tipo nao encontrado');
      return;
    }

    var descrOrcamento = novoProdutoCategoria + ' - ' + novoProdutoNome;
    var description = novoProdutoTamanho + ' - ' + novoProdutoNome;

    var faixasFormatadas = novoProdutoFaixas.map(function(faixa) {
      return {
        QtdTotal: parseInt(faixa.qtd),
        PrecoUnitario: parseFloat(faixa.preco)
      };
    });

    setCarregando(true);
    try {
      await axios.post(REQUEST_URL + '/Produto/adicionar_produto', {
        DescrOrcamento: descrOrcamento,
        DescrProjeto: tipoSelecionado.DescrProjeto,
        IDProject: tipoSelecionado.IDProject,
        DescrComponente: novoProdutoComponente || '',
        DescProoduto: novoProdutoTamanho,
        Description: description,
        faixasPreco: faixasFormatadas
      });

      toast.success('Produto adicionado com sucesso!');
      fecharModalNovoProduto();

      if (servicoSelecionado === novoProdutoCategoria) {
        await selecionarServico(servicoSelecionado);
      }
    } catch (error) {
      toast.error('Erro ao adicionar produto');
    }
    setCarregando(false);
  };

  var percentualNum = modoVisualizacao === 'acabamentos' ? (parseFloat(valorPercentualAcab) || 0) : (parseFloat(valorPercentual) || 0);
  var temPercentual = modoVisualizacao === 'acabamentos'
    ? (valorPercentualAcab !== '' && !isNaN(percentualNum))
    : (valorPercentual !== '' && !isNaN(percentualNum));

  return (
    <div style={{ backgroundColor: '#f5f4f9', paddingBottom: 30, position: 'relative', minHeight: '100vh' }}>
      <ToastContainer position='bottom-left' autoClose={3000} />
      <NavBar nome={usuarioLogado.Nome} funcao={usuarioLogado.Funcao} />

      <Modal isOpen={modalConfirmacao} toggle={function() { setModalConfirmacao(false); }}>
        <ModalHeader toggle={function() { setModalConfirmacao(false); }}>
          Confirmar Ajuste
        </ModalHeader>
        <ModalBody>
          <Alert color='warning'>
            <strong>{totalRegistros}</strong> registro(s) serao alterados
          </Alert>
          <p><strong>Alvo:</strong> {getNivelLabel()}</p>
          <p>
            <strong>Ajuste:</strong>{' '}
            <Badge color={percentualNum >= 0 ? 'success' : 'danger'} style={{ fontSize: '1rem' }}>
              {percentualNum >= 0 ? '+' : ''}{modoVisualizacao === 'acabamentos' ? valorPercentualAcab : valorPercentual}%
            </Badge>
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color='success' onClick={modoVisualizacao === 'acabamentos' ? aplicarAlteracaoAcab : aplicarAlteracao}>Confirmar</Button>
          <Button color='secondary' onClick={function() { setModalConfirmacao(false); }}>Cancelar</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalNovoProduto} toggle={fecharModalNovoProduto} size='lg'>
        <ModalHeader toggle={fecharModalNovoProduto}>
          {modoVisualizacao === 'acabamentos' ? 'Adicionar Novo Acabamento' : 'Adicionar Novo Produto'}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={modoVisualizacao === 'acabamentos' ? 12 : 6}>
              <FormGroup>
                <Label><strong>Categoria *</strong></Label>
                <Input
                  type='select'
                  value={novoProdutoCategoria}
                  onChange={function(e) { selecionarCategoriaNovoProduto(e.target.value); }}
                >
                  <option value=''>Selecione...</option>
                  {servicos.map(function(item) {
                    return <option key={item} value={item}>{item}</option>;
                  })}
                </Input>
              </FormGroup>
            </Col>
            {modoVisualizacao === 'produtos' && (
              <Col md={6}>
                <FormGroup>
                  <Label><strong>Tipo *</strong></Label>
                  <Input
                    type='select'
                    value={novoProdutoTipo}
                    onChange={function(e) { setNovoProdutoTipo(e.target.value); }}
                    disabled={tiposDisponiveis.length === 0}
                  >
                    <option value=''>Selecione...</option>
                    {tiposDisponiveis.map(function(tipo) {
                      return <option key={tipo.IDProject} value={tipo.IDProject}>{tipo.DescrProjeto}</option>;
                    })}
                  </Input>
                </FormGroup>
              </Col>
            )}
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label><strong>{modoVisualizacao === 'acabamentos' ? 'Nome do Acabamento *' : 'Nome do Produto *'}</strong></Label>
                <Input
                  type='text'
                  value={novoProdutoNome}
                  onChange={function(e) { setNovoProdutoNome(e.target.value); }}
                  placeholder={modoVisualizacao === 'acabamentos' ? 'Ex: Verniz UV, Laminacao Fosca...' : 'Ex: Caixas Camisa com Tampa em Acrilico'}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label><strong>Tamanho *</strong></Label>
                <Input
                  type='text'
                  value={novoProdutoTamanho}
                  onChange={function(e) { setNovoProdutoTamanho(e.target.value); }}
                  placeholder='Ex: 20x30, A4, 15x21...'
                />
              </FormGroup>
            </Col>
          </Row>
          {modoVisualizacao === 'produtos' && (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label><strong>Componente</strong> <small className='text-muted'>(opcional)</small></Label>
                  <Input
                    type='text'
                    value={novoProdutoComponente}
                    onChange={function(e) { setNovoProdutoComponente(e.target.value); }}
                    placeholder='Ex: Tampa, Base, etc.'
                  />
                </FormGroup>
              </Col>
            </Row>
          )}

          <hr />

          {novoProdutoFaixas.map(function(faixa, index) {
            return (
              <Row key={index} style={{ marginBottom: 10, alignItems: 'center' }}>
                <Col md={4}>
                  <Input
                    type='number'
                    min='1'
                    value={faixa.qtd}
                    onChange={function(e) { atualizarFaixaPreco(index, 'qtd', e.target.value); }}
                    placeholder='Quantidade'
                    invalid={faixa.qtd !== '' && (isNaN(parseInt(faixa.qtd)) || parseInt(faixa.qtd) <= 0)}
                  />
                </Col>
                <Col md={4}>
                  <Input
                    type='number'
                    step='0.01'
                    min='0.01'
                    value={faixa.preco}
                    onChange={function(e) { atualizarFaixaPreco(index, 'preco', e.target.value); }}
                    placeholder='Preco Unitario (R$)'
                    invalid={faixa.preco !== '' && (isNaN(parseFloat(faixa.preco)) || parseFloat(faixa.preco) <= 0)}
                  />
                </Col>
                <Col md={3}>
                  {faixa.qtd && faixa.preco && !isNaN(parseInt(faixa.qtd)) && !isNaN(parseFloat(faixa.preco)) && (
                    <small className='text-muted'>
                      Total: {formatarMoeda(parseInt(faixa.qtd) * parseFloat(faixa.preco))}
                    </small>
                  )}
                </Col>
                <Col md={1}>
                  {novoProdutoFaixas.length > 1 && (
                    <Button
                      color='danger'
                      size='sm'
                      onClick={function() { removerFaixaPreco(index); }}
                      style={{ padding: '2px 8px' }}
                    >
                      <i className='fas fa-trash'></i>
                    </Button>
                  )}
                </Col>
              </Row>
            );
          })}
        </ModalBody>
        <ModalFooter>
          <Button color='success' onClick={salvarNovoProduto} disabled={carregando}>
            {carregando ? 'Salvando...' : (modoVisualizacao === 'acabamentos' ? 'Salvar Acabamento' : 'Salvar Produto')}
          </Button>
          <Button color='secondary' onClick={fecharModalNovoProduto}>Cancelar</Button>
        </ModalFooter>
      </Modal>

      <Row className='conteudo' style={{ margin: '0px' }}>
        <Col id='container' style={{ marginTop: 20 }}>

          <Card style={{ marginTop: 20, boxShadow: '0.5rem 0.5rem 2rem 0 rgb(8 15 41 / 8%)', borderRadius: '.375rem' }}>
            <CardHeader style={{ borderBottom: 'none', backgroundColor: 'white', borderRadius: '.375rem', fontSize: '1.2rem', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>Ajuste de Precos</span>
              <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                <Button
                  color='success'
                  size='sm'
                  onClick={abrirModalNovoProduto}
                >
                  <i className='fas fa-plus'></i> {modoVisualizacao === 'acabamentos' ? 'Novo Acabamento' : 'Novo Produto'}
                </Button>
                <div>
                  <Button
                    color={modoVisualizacao === 'produtos' ? 'primary' : 'outline-primary'}
                    size='sm'
                    onClick={function() { trocarModo('produtos'); }}
                    style={{ marginRight: 5 }}
                  >
                    Produtos
                  </Button>
                  <Button
                    color={modoVisualizacao === 'acabamentos' ? 'info' : 'outline-info'}
                    size='sm'
                    onClick={function() { trocarModo('acabamentos'); }}
                  >
                    Acabamentos
                  </Button>
                </div>
              </div>
            </CardHeader>
            <CardBody>

              {carregando && (
                <Alert color='info' className='text-center'>
                  <i className='fa fa-spinner fa-pulse fa-fw'></i> Carregando...
                </Alert>
              )}

              {modoVisualizacao === 'produtos' && (
                <React.Fragment>
                  <Row>
                    <Col md={3}>
                      <FormGroup>
                        <Label><strong>Categoria</strong></Label>
                        <Input type='select' value={servicoSelecionado} onChange={function(e) { selecionarServico(e.target.value); }}>
                          <option value=''>Selecione...</option>
                          {servicos.map(function(item) {
                            return <option key={item} value={item}>{item}</option>;
                          })}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label><strong>Tipo</strong></Label>
                        <Input type='select' value={projetoSelecionado ? projetoSelecionado.IDProject : ''} onChange={function(e) { selecionarProjeto(e.target.value); }} disabled={projetos.length === 0}>
                          <option value=''>Selecione...</option>
                          {projetos.map(function(proj) {
                            return <option key={proj.IDProject} value={proj.IDProject}>{proj.DescrProjeto}</option>;
                          })}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label><strong>Produto</strong></Label>
                        <Input type='select' value={itemSelecionado ? itemSelecionado.IdQuote : ''} onChange={function(e) { selecionarItem(e.target.value); }} disabled={itens.length === 0}>
                          <option value=''>Selecione...</option>
                          {itens.map(function(item) {
                            return <option key={item.IdQuote} value={item.IdQuote}>{item.DescrOrcamento}</option>;
                          })}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label><strong>Tamanho</strong></Label>
                        <Input type='select' value={descricaoSelecionada ? descricaoSelecionada.Description : ''} onChange={function(e) { selecionarDescricao(e.target.value); }} disabled={descricoes.length === 0}>
                          <option value=''>Selecione...</option>
                          {descricoes
                            .sort(function(a, b) {
                              var areaA = parseInt(a.DescProoduto.substring(0, 2)) * parseInt(a.DescProoduto.substring(3, 5));
                              var areaB = parseInt(b.DescProoduto.substring(0, 2)) * parseInt(b.DescProoduto.substring(3, 5));
                              return areaA - areaB;
                            })
                            .map(function(desc) {
                              return <option key={desc.Description} value={desc.Description}>{desc.DescProoduto}</option>;
                            })}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  {listaPrecos.length > 0 && (
                    <div style={{ backgroundColor: '#e7f3ff', padding: 15, borderRadius: 8, marginTop: 10 }}>
                      <Row style={{ alignItems: 'flex-end' }}>
                        <Col md={3}>
                          <Label><strong>Ajuste em Lote</strong></Label>
                          <div className='input-group'>
                            <Input
                              type='number'
                              step='0.1'
                              value={valorPercentual}
                              onChange={function(e) { setValorPercentual(e.target.value); setLinhaEditando(null); }}
                              placeholder='Ex: 10 ou -5'
                              style={{ textAlign: 'center' }}
                            />
                            <div className='input-group-append'>
                              <span className='input-group-text'>%</span>
                            </div>
                          </div>
                        </Col>
                        <Col md={9}>
                          <div style={{ display: 'flex', gap: 8 }}>
                            <Button color='success' onClick={function() { abrirModalConfirmacao('item'); }} disabled={!temPercentual} size='sm'>
                              Este tamanho
                            </Button>
                            <Button color='warning' onClick={function() { abrirModalConfirmacao('projeto'); }} disabled={!temPercentual} size='sm'>
                              Todo o tipo
                            </Button>
                            <Button color='danger' onClick={function() { abrirModalConfirmacao('servico'); }} disabled={!temPercentual} size='sm'>
                              Categoria inteira
                            </Button>
                            {temPercentual && (
                              <Button color='secondary' onClick={function() { setValorPercentual(''); }} size='sm' outline>
                                Limpar
                              </Button>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  )}

                  {listaPrecos.length > 0 && (
                    <div style={{ marginTop: 20 }}>
                      <h6 style={{ marginBottom: 10 }}>
                        <strong>{descricaoSelecionada ? descricaoSelecionada.DescrOrcamento + ' - ' + descricaoSelecionada.DescProoduto : ''}</strong>
                      </h6>
                      <div className='table-responsive'>
                        <Table bordered size='sm' style={{ marginBottom: 0 }}>
                          <thead style={{ backgroundColor: '#343a40', color: 'white' }}>
                            <tr>
                              <th style={{ textAlign: 'center', width: 70 }}>Qtd</th>
                              <th style={{ textAlign: 'center', width: 110 }}>Anterior</th>
                              <th style={{ textAlign: 'center', width: 140 }}>Atual</th>
                              <th style={{ textAlign: 'center', width: 110 }}>Total</th>
                              <th style={{ textAlign: 'center', width: 80 }}>Var.</th>
                              {temPercentual && (
                                <React.Fragment>
                                  <th style={{ textAlign: 'center', width: 110, backgroundColor: '#28a745' }}>Novo Unit.</th>
                                  <th style={{ textAlign: 'center', width: 110, backgroundColor: '#28a745' }}>Novo Total</th>
                                </React.Fragment>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {listaPrecos.map(function(preco, index) {
                              var precoAnterior = preco.PrecoUnitarioAnterior || preco.PrecoUnitario;
                              var variacaoAtual = calcularPercentual(precoAnterior, preco.PrecoUnitario);
                              var temVariacao = preco.PrecoUnitarioAnterior && preco.PrecoUnitarioAnterior !== preco.PrecoUnitario;

                              var novoUnitProjecao = temPercentual ? preco.PrecoUnitario * (1 + percentualNum / 100) : null;
                              var novoTotalProjecao = novoUnitProjecao ? novoUnitProjecao * preco.QtdTotal : null;

                              var editandoEstaLinha = linhaEditando === index;
                              var valorEditadoNum = parseFloat(valorEditando) || 0;
                              var variacaoEditando = editandoEstaLinha ? calcularPercentual(preco.PrecoUnitario, valorEditadoNum) : 0;

                              return (
                                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa' }}>
                                  <td style={{ textAlign: 'center', fontWeight: 'bold', verticalAlign: 'middle' }}>
                                    {preco.QtdTotal}
                                  </td>
                                  <td style={{ textAlign: 'right', verticalAlign: 'middle', color: '#888' }}>
                                    {formatarMoeda(precoAnterior)}
                                  </td>
                                  <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                    {editandoEstaLinha ? (
                                      <div style={{ display: 'flex', gap: 4, alignItems: 'center', justifyContent: 'center' }}>
                                        <Input
                                          type='number'
                                          step='0.01'
                                          value={valorEditando}
                                          onChange={function(e) { setValorEditando(e.target.value); }}
                                          style={{ width: 80, textAlign: 'right', padding: '2px 5px' }}
                                          bsSize='sm'
                                          autoFocus
                                        />
                                        {valorEditadoNum !== preco.PrecoUnitario && (
                                          <Badge color={variacaoEditando >= 0 ? 'success' : 'danger'} style={{ fontSize: '0.7rem' }}>
                                            {variacaoEditando >= 0 ? '+' : ''}{variacaoEditando.toFixed(1)}%
                                          </Badge>
                                        )}
                                        <Button color='success' size='sm' onClick={function() { salvarLinhaIndividual(preco); }} style={{ padding: '2px 6px' }}>
                                          <i className='fas fa-check'></i>
                                        </Button>
                                        <Button color='secondary' size='sm' onClick={cancelarEdicao} style={{ padding: '2px 6px' }}>
                                          <i className='fas fa-times'></i>
                                        </Button>
                                      </div>
                                    ) : (
                                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8 }}>
                                        <span style={{ fontWeight: 'bold' }}>{formatarMoeda(preco.PrecoUnitario)}</span>
                                        <Button
                                          color='link'
                                          size='sm'
                                          onClick={function() { iniciarEdicaoLinha(index, preco.PrecoUnitario); }}
                                          style={{ padding: 0, color: '#007bff' }}
                                          title='Editar este preco'
                                        >
                                          <i className='fas fa-edit'></i>
                                        </Button>
                                      </div>
                                    )}
                                  </td>
                                  <td style={{ textAlign: 'right', verticalAlign: 'middle', fontWeight: 'bold' }}>
                                    {formatarMoeda(preco.PrecoUnitario * preco.QtdTotal)}
                                  </td>
                                  <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                    {temVariacao ? (
                                      <Badge color={variacaoAtual >= 0 ? 'success' : 'danger'} style={{ fontSize: '0.75rem' }}>
                                        {variacaoAtual >= 0 ? '+' : ''}{variacaoAtual.toFixed(1)}%
                                      </Badge>
                                    ) : '-'}
                                  </td>
                                  {temPercentual && (
                                    <React.Fragment>
                                      <td style={{ textAlign: 'right', verticalAlign: 'middle', backgroundColor: index % 2 === 0 ? '#d4edda' : '#c3e6cb', fontWeight: 'bold' }}>
                                        {formatarMoeda(novoUnitProjecao)}
                                      </td>
                                      <td style={{ textAlign: 'right', verticalAlign: 'middle', backgroundColor: index % 2 === 0 ? '#d4edda' : '#c3e6cb', fontWeight: 'bold' }}>
                                        {formatarMoeda(novoTotalProjecao)}
                                      </td>
                                    </React.Fragment>
                                  )}
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              )}

              {modoVisualizacao === 'acabamentos' && (
                <React.Fragment>
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label><strong>Categoria</strong></Label>
                        <Input type='select' value={servicoAcabSelecionado} onChange={function(e) { selecionarServicoAcab(e.target.value); }}>
                          <option value=''>Selecione...</option>
                          {servicos.map(function(item) {
                            return <option key={item} value={item}>{item}</option>;
                          })}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={8}>
                      <FormGroup>
                        <Label><strong>Acabamento</strong></Label>
                        <Input type='select' value={acabamentoSelecionado ? acabamentoSelecionado.IdOpcaoProduto : ''} onChange={function(e) { selecionarAcabamento(e.target.value); }} disabled={acabamentos.length === 0}>
                          <option value=''>Selecione...</option>
                          {acabamentos.map(function(acab) {
                            return <option key={acab.IdOpcaoProduto} value={acab.IdOpcaoProduto}>{acab.DescrComponente} - {acab.DescProoduto}</option>;
                          })}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  {listaPrecosAcab.length > 0 && (
                    <div style={{ backgroundColor: '#e0f7fa', padding: 15, borderRadius: 8, marginTop: 10 }}>
                      <Row style={{ alignItems: 'flex-end' }}>
                        <Col md={3}>
                          <Label><strong>Ajuste em Lote</strong></Label>
                          <div className='input-group'>
                            <Input
                              type='number'
                              step='0.1'
                              value={valorPercentualAcab}
                              onChange={function(e) { setValorPercentualAcab(e.target.value); setLinhaEditandoAcab(null); }}
                              placeholder='Ex: 10 ou -5'
                              style={{ textAlign: 'center' }}
                            />
                            <div className='input-group-append'>
                              <span className='input-group-text'>%</span>
                            </div>
                          </div>
                        </Col>
                        <Col md={9}>
                          <div style={{ display: 'flex', gap: 8 }}>
                            <Button color='success' onClick={function() { abrirModalConfirmacaoAcab('item'); }} disabled={!temPercentual} size='sm'>
                              Este acabamento
                            </Button>
                            <Button color='danger' onClick={function() { abrirModalConfirmacaoAcab('servico'); }} disabled={!temPercentual} size='sm'>
                              Categoria inteira
                            </Button>
                            {temPercentual && (
                              <Button color='secondary' onClick={function() { setValorPercentualAcab(''); }} size='sm' outline>
                                Limpar
                              </Button>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  )}

                  {listaPrecosAcab.length > 0 && (
                    <div style={{ marginTop: 20 }}>
                      <h6 style={{ marginBottom: 10 }}>
                        <strong>{acabamentoSelecionado ? acabamentoSelecionado.DescrComponente + ' - ' + acabamentoSelecionado.DescProoduto : ''}</strong>
                      </h6>
                      <div className='table-responsive'>
                        <Table bordered size='sm' style={{ marginBottom: 0 }}>
                          <thead style={{ backgroundColor: '#17a2b8', color: 'white' }}>
                            <tr>
                              <th style={{ textAlign: 'center', width: 70 }}>Qtd</th>
                              <th style={{ textAlign: 'center', width: 110 }}>Anterior</th>
                              <th style={{ textAlign: 'center', width: 140 }}>Atual</th>
                              <th style={{ textAlign: 'center', width: 110 }}>Total</th>
                              <th style={{ textAlign: 'center', width: 80 }}>Var.</th>
                              {temPercentual && (
                                <React.Fragment>
                                  <th style={{ textAlign: 'center', width: 110, backgroundColor: '#28a745' }}>Novo Unit.</th>
                                  <th style={{ textAlign: 'center', width: 110, backgroundColor: '#28a745' }}>Novo Total</th>
                                </React.Fragment>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {listaPrecosAcab.map(function(preco, index) {
                              var precoAnterior = preco.PrecoUnitarioAnterior || preco.PrecoUnitario;
                              var variacaoAtual = calcularPercentual(precoAnterior, preco.PrecoUnitario);
                              var temVariacao = preco.PrecoUnitarioAnterior && preco.PrecoUnitarioAnterior !== preco.PrecoUnitario;

                              var novoUnitProjecao = temPercentual ? preco.PrecoUnitario * (1 + percentualNum / 100) : null;
                              var novoTotalProjecao = novoUnitProjecao ? novoUnitProjecao * preco.QtdTotal : null;

                              var editandoEstaLinha = linhaEditandoAcab === index;
                              var valorEditadoNum = parseFloat(valorEditandoAcab) || 0;
                              var variacaoEditando = editandoEstaLinha ? calcularPercentual(preco.PrecoUnitario, valorEditadoNum) : 0;

                              return (
                                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa' }}>
                                  <td style={{ textAlign: 'center', fontWeight: 'bold', verticalAlign: 'middle' }}>
                                    {preco.QtdTotal}
                                  </td>
                                  <td style={{ textAlign: 'right', verticalAlign: 'middle', color: '#888' }}>
                                    {formatarMoeda(precoAnterior)}
                                  </td>
                                  <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                    {editandoEstaLinha ? (
                                      <div style={{ display: 'flex', gap: 4, alignItems: 'center', justifyContent: 'center' }}>
                                        <Input
                                          type='number'
                                          step='0.01'
                                          value={valorEditandoAcab}
                                          onChange={function(e) { setValorEditandoAcab(e.target.value); }}
                                          style={{ width: 80, textAlign: 'right', padding: '2px 5px' }}
                                          bsSize='sm'
                                          autoFocus
                                        />
                                        {valorEditadoNum !== preco.PrecoUnitario && (
                                          <Badge color={variacaoEditando >= 0 ? 'success' : 'danger'} style={{ fontSize: '0.7rem' }}>
                                            {variacaoEditando >= 0 ? '+' : ''}{variacaoEditando.toFixed(1)}%
                                          </Badge>
                                        )}
                                        <Button color='success' size='sm' onClick={function() { salvarLinhaIndividualAcab(preco); }} style={{ padding: '2px 6px' }}>
                                          <i className='fas fa-check'></i>
                                        </Button>
                                        <Button color='secondary' size='sm' onClick={cancelarEdicaoAcab} style={{ padding: '2px 6px' }}>
                                          <i className='fas fa-times'></i>
                                        </Button>
                                      </div>
                                    ) : (
                                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8 }}>
                                        <span style={{ fontWeight: 'bold' }}>{formatarMoeda(preco.PrecoUnitario)}</span>
                                        <Button
                                          color='link'
                                          size='sm'
                                          onClick={function() { iniciarEdicaoLinhaAcab(index, preco.PrecoUnitario); }}
                                          style={{ padding: 0, color: '#17a2b8' }}
                                          title='Editar este preco'
                                        >
                                          <i className='fas fa-edit'></i>
                                        </Button>
                                      </div>
                                    )}
                                  </td>
                                  <td style={{ textAlign: 'right', verticalAlign: 'middle', fontWeight: 'bold' }}>
                                    {formatarMoeda(preco.PrecoUnitario * preco.QtdTotal)}
                                  </td>
                                  <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                    {temVariacao ? (
                                      <Badge color={variacaoAtual >= 0 ? 'success' : 'danger'} style={{ fontSize: '0.75rem' }}>
                                        {variacaoAtual >= 0 ? '+' : ''}{variacaoAtual.toFixed(1)}%
                                      </Badge>
                                    ) : '-'}
                                  </td>
                                  {temPercentual && (
                                    <React.Fragment>
                                      <td style={{ textAlign: 'right', verticalAlign: 'middle', backgroundColor: index % 2 === 0 ? '#d4edda' : '#c3e6cb', fontWeight: 'bold' }}>
                                        {formatarMoeda(novoUnitProjecao)}
                                      </td>
                                      <td style={{ textAlign: 'right', verticalAlign: 'middle', backgroundColor: index % 2 === 0 ? '#d4edda' : '#c3e6cb', fontWeight: 'bold' }}>
                                        {formatarMoeda(novoTotalProjecao)}
                                      </td>
                                    </React.Fragment>
                                  )}
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              )}
            </CardBody>
          </Card>

        </Col>
      </Row>
    </div>
  );
};

export default Produtos;
